// extracted by mini-css-extract-plugin
module.exports = {"container":"TN","imgContainer":"UN","content":"VN","brand":"WN","product":"XN","price":"YN","noLink":"ZN"};